import { useMemo } from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getApprovalsTransactions } from 'services/ApprovalsService'

export const useApprovalsTransactionsQuery = (
  currentAccountReference: string,
  status: string,
  isEnabled = false,
  pageSize: number = 100
) => {
  const { data, fetchNextPage, ...rest } = useInfiniteQuery({
    enabled: isEnabled,
    initialPageParam: 0,
    queryKey: reactQueryKeys.approvalsTransactions(currentAccountReference, status, pageSize),
    queryFn: ({ pageParam }) =>
      getApprovalsTransactions(currentAccountReference, status, pageParam, pageSize),
    getNextPageParam: (_lastPage, _allPages, lastPageParam) => lastPageParam + 1,
  })

  const { allApprovals, hasNextPage } = useMemo(() => {
    const allApprovals = data?.pages.flat() ?? []
    const hasNextPage = (data?.pages?.at(-1)?.length || 0) >= pageSize
    return {
      allApprovals,
      hasNextPage,
    }
  }, [data?.pageParams, data?.pages, pageSize])

  return {
    ...rest,
    data: allApprovals,
    hasNextPage,
    fetchNextPage: hasNextPage ? fetchNextPage : undefined,
  }
}
